import React, { memo } from 'react';
import ModalReferal from 'components/Modals/ModalReferral';
import {
  // FiGift,
  FiHelpCircle,
  FiSettings,
  FiDownload,
  FiInfo,
  FiFileText,
  FiPieChart,
  FiLogOut,
} from 'react-icons/fi';
import { Props } from './types';
import {
  Container,
  Menu,
  DrawerContainer,
  Heading,
  LogoContainer,
  Logo,
  LinksContainer,
  Link,
  LogoutButton,
  LinkText,
  Button,
  ButtonsContainer,
  FiOrders,
  FiHistory,
  IconContainer,
  Section,
} from './styles';

const Desktop = ({
  openReferal,
  handleOpenReferal,
  handleCloseReferal,
  handleLogout,
  openMenu,
  handleCloseMenu,
  canAccessInsights,
  hasOrdering,
}: Props) => {
  const isDrawer = !!handleCloseMenu;

  if (isDrawer) {
    return (
      <>
        {openReferal && <ModalReferal handleClose={handleCloseReferal} />}
        <DrawerContainer open={openMenu} onClose={handleCloseMenu}>
          <Section>
            <Heading>
              <Logo />
            </Heading>

            <LinksContainer>
              {hasOrdering && (
                <Link
                  to="/orders"
                  label="Orders"
                  icon={<FiOrders />}
                  onClick={handleCloseMenu}
                />
              )}
              {canAccessInsights && (
                <Link
                  to="/insights"
                  label="Insights"
                  icon={<FiPieChart />}
                  onClick={handleCloseMenu}
                />
              )}
              {/* <Link
                to="/rewards"
                label="Rewards"
                icon={<FiGift />}
                onClick={handleCloseMenu}
              /> */}
              <Link
                to="/history"
                label="History"
                icon={<FiHistory />}
                onClick={handleCloseMenu}
              />
              {hasOrdering && (
                <Link
                  to="/menu-manager"
                  label="Menu"
                  icon={<FiFileText />}
                  onClick={handleCloseMenu}
                />
              )}
              {hasOrdering && (
                <Link
                  to="/reporting"
                  label="Reporting"
                  icon={<FiDownload />}
                  onClick={handleCloseMenu}
                />
              )}
              <Link
                to="/support"
                label="Support"
                icon={<FiHelpCircle />}
                onClick={handleCloseMenu}
              />
              <Link
                to="/settings"
                label="Settings"
                icon={<FiSettings />}
                onClick={handleCloseMenu}
              />
            </LinksContainer>
          </Section>

          <ButtonsContainer>
            <Button onClick={handleOpenReferal} type="button">
              <IconContainer>
                <FiInfo />
              </IconContainer>
              Refer & earn $100
            </Button>

            <LogoutButton onClick={handleLogout}>
              <IconContainer>
                <FiLogOut />
              </IconContainer>
              <LinkText>Log out</LinkText>
            </LogoutButton>
          </ButtonsContainer>
        </DrawerContainer>
      </>
    );
  }

  return (
    <Container>
      <Menu>
        <Section>
          <Heading>
            <LogoContainer to="/">
              <Logo />
            </LogoContainer>
          </Heading>

          <LinksContainer>
            {hasOrdering && (
              <Link to="/orders" label="Orders" icon={<FiOrders />} />
            )}
            {canAccessInsights && (
              <Link to="/insights" label="Insights" icon={<FiPieChart />} />
            )}
            {/* <Link to="/rewards" label="Rewards" icon={<FiGift />} /> */}
            <Link to="/history" label="History" icon={<FiHistory />} />
            {hasOrdering && (
              <>
                <Link to="/menu-manager" label="Menu" icon={<FiFileText />} />
                <Link to="/reporting" label="Reporting" icon={<FiDownload />} />
              </>
            )}
            <Link to="/support" label="Support" icon={<FiHelpCircle />} />
            <Link to="/settings" label="Settings" icon={<FiSettings />} />
          </LinksContainer>
        </Section>

        <ButtonsContainer>
          <Button onClick={handleOpenReferal} type="button">
            <IconContainer>
              <FiInfo />
            </IconContainer>
            Refer & earn $100
          </Button>
          {openReferal && <ModalReferal handleClose={handleCloseReferal} />}
          <LogoutButton onClick={handleLogout}>
            <IconContainer>
              <FiLogOut />
            </IconContainer>
            <LinkText>Log out</LinkText>
          </LogoutButton>
        </ButtonsContainer>
      </Menu>
    </Container>
  );
};

export default memo(Desktop);

// TODO: TFR-29 add story
